import { fetchAuthSession } from "aws-amplify/auth";

const BASE = import.meta.env.VITE_API_BASE || "https://api.binker.nl";

async function authHeader(): Promise<Record<string, string>> {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

/** GET. Zet { auth: true } voor beveiligde admin-endpoints (stuurt de Cognito ID-token mee). */
export async function apiGet<T>(path: string, opts: { auth?: boolean } = {}): Promise<T> {
  const headers: Record<string, string> = { "content-type": "application/json" };
  if (opts.auth) Object.assign(headers, await authHeader());
  const res = await fetch(`${BASE}${path}`, { headers });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<T>;
}

/** Beveiligde schrijf-call (POST/PUT/PATCH/DELETE) — stuurt altijd de admin-token mee. */
export async function apiSend<T>(method: string, path: string, body?: unknown): Promise<T> {
  const headers: Record<string, string> = { "content-type": "application/json", ...(await authHeader()) };
  const res = await fetch(`${BASE}${path}`, { method, headers, body: body ? JSON.stringify(body) : undefined });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { const d = await res.json(); if (d?.message) msg = d.message; } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json() as Promise<T>;
}
export const apiPost = <T>(path: string, body: unknown) => apiSend<T>("POST", path, body);
export const apiPut = <T>(path: string, body: unknown) => apiSend<T>("PUT", path, body);
export const apiPatch = <T>(path: string, body: unknown) => apiSend<T>("PATCH", path, body);
